
window.ckeditorCounter = (props = { maxLength: 3000, height: '200px' }) => {

    return {
        editor: null,
        characterCount: 0,
        maxLength: props?.maxLength,
        height: props?.height,
        showToolTip: false,
        async init() {
            await this.initEditor()
            await this.countCharacters();
        },
        initEditor() {
            var _slef = this
            CKEDITOR.plugins.addExternal('wordcount', '/wordcount/', 'plugin.js');

            this.editor = CKEDITOR.replace(this.$refs.editor, {
                // enterMode: CKEDITOR.ENTER_DIV, // Use div instead of p
                // shiftEnterMode: CKEDITOR.ENTER_BR,
                colorButton_enableAutomatic: false,
                height: _slef.height,
                extraPlugins: 'wordcount,notification',
                removePlugins: 'elementspath',
                // Define the toolbar groups as it is a more accessible solution.
                toolbarGroups: [
                    // { name: 'clipboard',   groups: [ 'clipboard', 'undo' ] },
                    // { name: 'editing',     groups: [ 'find', 'selection', 'spellchecker' ] },
                    // { name: 'links' },
                    // { name: 'forms' },
                    // { name: 'document',       groups: [ 'mode', 'document', 'doctools' ] },
                    { name: 'others' },
                    { name: 'basicstyles', groups: ['basicstyles'] },
                    { name: 'paragraph', groups: ['list', 'blocks', 'align'] },
                    { name: 'insert' },
                    // { name: 'styles' },
                    // { name: 'colors' },
                    { name: 'tools' },

                    // { name: 'about' }
                ],
                // Remove the redundant buttons from toolbar groups defined above.
                removeButtons: 'Strike,Subscript,Superscript,Anchor,Styles,Specialchar,CreateDiv,Blockquote,ShowBlocks,Language,Table,Image,Smiley,PageBreak,SpecialChar',
                versionCheck: false,
                wordcount: {

                    // Whether or not you Show Remaining Count (if Maximum Word/Char/Paragraphs Count is set)
                    showRemaining: false,

                    // Whether or not you want to show the Paragraphs Count
                    showParagraphs: false,

                    // Whether or not you want to show the Word Count
                    showWordCount: false,

                    // Whether or not you want to show the Char Count
                    showCharCount: true,

                    // Whether or not you want to Count Bytes as Characters (needed for Multibyte languages such as Korean and Chinese)
                    countBytesAsChars: false,

                    // Whether or not you want to count Spaces as Chars
                    countSpacesAsChars: true,

                    // Whether or not to include Html chars in the Char Count
                    countHTML: false,

                    // Whether or not to include Line Breaks in the Char Count
                    countLineBreaks: false,

                    // Whether or not to prevent entering new Content when limit is reached.
                    hardLimit: true,

                    // Whether or not to to Warn only When limit is reached. Otherwise content above the limit will be deleted on paste or entering
                    warnOnLimitOnly: false,

                    // Maximum allowed Word Count, -1 is default for unlimited
                    maxWordCount: -1,

                    // Maximum allowed Char Count, -1 is default for unlimited
                    maxCharCount: this.maxLength,

                    // Maximum allowed Paragraphs Count, -1 is default for unlimited
                    maxParagraphs: -1,

                    // How long to show the 'paste' warning, 0 is default for not auto-closing the notification
                    pasteWarningDuration: 3000,


                    // Add filter to add or remove element before counting (see CKEDITOR.htmlParser.filter), Default value : null (no filter)
                    filter: new CKEDITOR.htmlParser.filter({
                        elements: {
                            div: function (element) {
                                if (element.attributes.class == 'mediaembed') {
                                    return false;
                                }
                            }
                        }
                    })
                }
            });
            setTimeout(() => {
                this.showToolTip = true;
            }, 200);
            var editor = CKEDITOR.instances.editor;
            this.editor.on('change', () => {
                this.editor.updateElement();
            });

            this.editor.on('paste', (event) => {
                // Your custom logic here if needed
                // console.log('Content pasted:', event);

                // Trigger a content update
                setTimeout(function () {
                    editor.updateElement();
                }, 100);
            });
            this.editor.on('contentDom', () => {
                //     this.editor.document.on('input', (event) => {
                //         this.countCharacters();
                //     });

                this.editor.document.on('keyup', () => {
                    const text = this.editor.getData();
                    const plainText = text.replace(/<br\s*\/?>/g, '\n').replace(/<[^>]*>/g, '');
                    const refinedText = $('<div/>').html(plainText)
                                                    .text()
                                                    .replace(/\u00A0/g, ' ')  ;// Replace non-breaking spaces with normal spaces
                    Livewire.emit('setDescription', text);
                    if (document.getElementById('new_description')) {
                        //document.getElementById('new_description').value = text;
                        document.getElementById('new_description').value = refinedText;                                                                          
                        validateByField('#pre_project_form','new_description');
                    }
                    if (document.getElementById('editor')) {
                        document.getElementById('editor').value = text;
                    }
                    Livewire.emit('changeForm');
                });

                this.editor.document.on('focusout', () => {
                    const text = this.editor.getData();
                    Livewire.emit('setDescription', text);
                    const plainText = text.replace(/<br\s*\/?>/g, '\n').replace(/<[^>]*>/g, '');
                    const refinedText = $('<div/>').html(plainText).text().replace(/\u00A0/g, ' ');
                    if (document.getElementById('new_description')) {
                        //document.getElementById('new_description').value = text;
                        document.getElementById('new_description').value = refinedText;                                                                        
                        validateByField('#pre_project_form','new_description');
                    }
                    if (document.getElementById('editor')) {
                        document.getElementById('editor').value = text;
                    }
                });

                // this.editor.document.on('mouseout', () => {
                //     const text = this.editor.getData();
                //     Livewire.emit('setDescription',text);
                // });

            });
        },


        countCharacters() {
            if (this.editor) {
                const text = this.editor.getData();
                Livewire.emit('setDescription', text);

                // Remove HTML tags to get the plain text character count.
                const plainText = text.replace(/<[^>]*>/g, '');
                if (document.getElementById('new_description')) {
                    document.getElementById('new_description').value = plainText;
                }
                this.characterCount = plainText.length;
            }
        },


        $nextTick() {
            this.initEditor();
        },
    };
}
window.metaDescriptionCkeditor = (props = { height: '200px', maxLength: 2500 }) => {

    return {
        editor: null,
        characterCount: 0,
        height: props?.height,
        maxLength: props?.maxLength,
        showToolTip: false,
        async init() {
            await this.initEditor()
            await this.countCharacters();

        },
        initEditor() {
            var _slef = this
            CKEDITOR.plugins.addExternal('wordcount', '/wordcount/', 'plugin.js');
            CKEDITOR.plugins.addExternal('font', '/ckeditor-font/', 'plugin.js');
            CKEDITOR.plugins.addExternal('lineheight', '/lineheight/', 'plugin.js');

            this.editor = CKEDITOR.replace(this.$refs.editor, {
                on: {
                    key: function (event) {
                        var editor = event.editor;
                        var content = editor.getData();
                    },
                    // paste: function(event){
                    // var editor = event.editor;
                    // var content = event.editor._.data;
                    // const plainText = content.replace(/<[^>]*>/g, '');

                    // console.log(content.length,_slef.editor._.data);
                    // if (plainText.length > _slef.maxLength) {
                    //     console.log('SASDADASDASD', this.editor );
                    //     _slef.editor.setData(content.substring(0,_slef.maxLength));
                    // //     event.cancel();
                    // }

                    // setTimeout(() => {
                    //             _slef.countCharacters();
                    //         }, 1000);
                    // },

                },
                height: _slef.height,
                extraPlugins: 'wordcount,notification,font,lineheight',
                toolbarGroups: [
                    { name: 'clipboard', groups: ['clipboard', 'undo'] },
                    { name: 'editing', groups: ['find', 'selection', 'spellchecker'] },
                    { name: 'links' },
                    { name: 'insert' },
                    { name: 'forms' },
                    { name: 'tools' },
                    { name: 'document', groups: ['mode', 'document', 'doctools'] },
                    { name: 'others' },
                    '/',
                    { name: 'basicstyles', groups: ['basicstyles', 'cleanup'] },
                    { name: 'paragraph', groups: ['list', 'indent', 'blocks', 'align', 'bidi'] },
                    { name: 'styles' },
                    { name: 'colors' },
                    // { name: 'about' }
                ],
                versionCheck: false,
                wordcount: {

                    // Whether or not you Show Remaining Count (if Maximum Word/Char/Paragraphs Count is set)
                    showRemaining: false,

                    // Whether or not you want to show the Paragraphs Count
                    showParagraphs: false,

                    // Whether or not you want to show the Word Count
                    showWordCount: false,

                    // Whether or not you want to show the Char Count
                    showCharCount: true,

                    // Whether or not you want to Count Bytes as Characters (needed for Multibyte languages such as Korean and Chinese)
                    countBytesAsChars: false,

                    // Whether or not you want to count Spaces as Chars
                    countSpacesAsChars: true,

                    // Whether or not to include Html chars in the Char Count
                    countHTML: false,

                    // Whether or not to include Line Breaks in the Char Count
                    countLineBreaks: false,

                    // Whether or not to prevent entering new Content when limit is reached.
                    hardLimit: true,

                    // Whether or not to to Warn only When limit is reached. Otherwise content above the limit will be deleted on paste or entering
                    warnOnLimitOnly: false,

                    // Maximum allowed Word Count, -1 is default for unlimited
                    maxWordCount: -1,

                    // Maximum allowed Char Count, -1 is default for unlimited
                    maxCharCount: this.maxLength,

                    // Maximum allowed Paragraphs Count, -1 is default for unlimited
                    maxParagraphs: -1,

                    // How long to show the 'paste' warning, 0 is default for not auto-closing the notification
                    pasteWarningDuration: 0,


                    // Add filter to add or remove element before counting (see CKEDITOR.htmlParser.filter), Default value : null (no filter)
                    filter: new CKEDITOR.htmlParser.filter({
                        elements: {
                            div: function (element) {
                                if (element.attributes.class == 'mediaembed') {
                                    return false;
                                }
                            }
                        }
                    })
                }

            });
            setTimeout(() => {
                this.showToolTip = true;
                this.countCharacters();
            }, 200);
            this.editor.on((e) => {
            })
            this.editor.on('contentDom', () => {
                this.editor.document.on('input', (event) => {
                    this.countCharacters();
                });

                this.editor.document.on('keyup', () => {
                    this.countCharacters();
                });

                this.editor.document.on('mouseout', () => {
                    this.countCharacters();
                });

            });
            this.editor.on('paste', () => {
                //     //Delay the character count update to ensure the pasted content is available.
                setTimeout(() => {
                    this.countCharacters();
                }, 50);
            });
        },


        countCharacters() {
            if (this.editor) {
                const text = this.editor.getData();
                Livewire.emit('setDescription', text);

                // Remove HTML tags to get the plain text character count.
                const plainText = text.replace(/<[^>]*>/g, '');
                Livewire.emit('descriptionwithouthtml', plainText);
                this.characterCount = plainText.length;
            }
        },


        $nextTick() {
            this.initEditor();
        },
    };
}